import { Tooltip, TooltipProps } from "@mantine/core";

export function TooltipMultiline(props: TooltipProps) {
    return <>
        {
            props.label ? <Tooltip position="top-start" multiline events={{ hover: true, focus: false, touch: true }} style={{ whiteSpace: "pre-line" }} {...props} /> : props.children
        }
    </>
}